/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { DepartmentsControllerFindAllQueryResponse, DepartmentsControllerFindAllQueryParams, DepartmentsControllerFindAll401, DepartmentsControllerFindAll403 } from "../../models/departmentsController/DepartmentsControllerFindAll";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { departmentsControllerFindAll } from "../../clients/departmentsService/departmentsControllerFindAll";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const departmentsControllerFindAllQueryKey = (params: DepartmentsControllerFindAllQueryParams = {}) => [{
  url: '/api/v1/departments'
}, ...(params ? [params] : [])] as const;
export type DepartmentsControllerFindAllQueryKey = ReturnType<typeof departmentsControllerFindAllQueryKey>;
export function departmentsControllerFindAllQueryOptions(params?: DepartmentsControllerFindAllQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = departmentsControllerFindAllQueryKey(params);
  return queryOptions<DepartmentsControllerFindAllQueryResponse, ResponseErrorConfig<DepartmentsControllerFindAll401 | DepartmentsControllerFindAll403>, DepartmentsControllerFindAllQueryResponse, typeof queryKey>({
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return departmentsControllerFindAll(params, config);
    }
  });
}

/**
 * @summary Get all departments
 * {@link /api/v1/departments}
 */
export function useDepartmentsControllerFindAll<TData = DepartmentsControllerFindAllQueryResponse, TQueryData = DepartmentsControllerFindAllQueryResponse, TQueryKey extends QueryKey = DepartmentsControllerFindAllQueryKey>(params?: DepartmentsControllerFindAllQueryParams, options: {
  query?: Partial<QueryObserverOptions<DepartmentsControllerFindAllQueryResponse, ResponseErrorConfig<DepartmentsControllerFindAll401 | DepartmentsControllerFindAll403>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? departmentsControllerFindAllQueryKey(params);
  const query = useQuery({
    ...departmentsControllerFindAllQueryOptions(params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<DepartmentsControllerFindAll401 | DepartmentsControllerFindAll403>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}